import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { CreateProfessionnelTirage } from "src/app/professionnel/core/model/tirage/create-professionnel-tirage";
import { ProfessionnelTirageService } from "src/app/professionnel/core/service/professionnel-tirage.service";

@Component({
  selector: "app-add-tirage",
  templateUrl: "./add-tirage.component.html",
  styleUrls: ["./add-tirage.component.scss"],
})
export class AddTirageComponent implements OnInit {
  @Input() professionnelFaciliteId;

  createProfessionnelTirage: CreateProfessionnelTirage =
    new CreateProfessionnelTirage();

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService,
    private _professionnelTirageService: ProfessionnelTirageService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      montant: [null, Validators.compose([Validators.required])],
      dateTirage: [null, Validators.compose([Validators.required])],
      echeance: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.createProfessionnelTirage.faciliteId = this.professionnelFaciliteId;
  }

  save(): void {
    this.createProfessionnelTirage.dateTirage =
      this.convertDateJsonToDateString(this.form2.value.dateTirage, {
        hour: 1,
        minute: 1,
      });

    this.spinner.show();
    this._professionnelTirageService
      .add(this.createProfessionnelTirage)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  convertDateJsonToDateString(date, time) {
    let month;
    month = date.month;
    if (date.month < 10) {
      month = "0" + date.month;
    }

    let day;
    day = date.day;
    if (date.day < 10) {
      day = "0" + date.day;
    }

    //

    let hour;
    hour = time.hour;
    if (time.hour < 10) {
      hour = "0" + time.hour;
    }

    let minute;
    minute = time.minute;
    if (time.minute < 10) {
      minute = "0" + time.minute;
    }

    let datetime =
      date.year +
      "-" +
      month +
      "-" +
      day +
      "T" +
      hour +
      ":" +
      minute +
      ":00.756Z";
    return datetime;
  }

  convertDateStringToDateJson(date: string) {
    let dateSimple = new Date(date);
    let dateJson = {
      year: dateSimple.getFullYear(),
      month: dateSimple.getMonth() + 1,
      day: dateSimple.getDate(),
    };
    return dateJson;
  }
}
